<template>
  <section class="resource-center-section pt-120 pb-100">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-8">
          <div class="section-title text-center mb-70">
            <h2>{{ content.header.title }}</h2>
            <p>{{ content.header.description }}</p>
          </div>
        </div>
      </div>

      <div class="row g-3 g-md-4">
        <div class="col-lg-4 col-md-6 h-aut" v-for="(resource, index) in content.resources" :key="index">
          <div class="resource-item h-100">
            <div class="resource-icon">
              <i :class="resource.icon"></i>
            </div>
            <div class="resource-content">
              <h3>{{ resource.title }}</h3>
              <p>{{ resource.description }}</p>
             
            </div>
          </div>
        </div>
      </div>

      
    </div>
  </section>
</template>

<script>
export default {
  name: 'TechItsResourceCenterComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url("https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

/* Resource Center Section */
.resource-center-section {
  position: relative;
  z-index: 1;
  padding-top: 120px;
  padding-bottom: 100px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.section-title {
  margin-bottom: 70px;
}

.section-title h2 {
  font-size: 40px;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 20px;
  font-family: "Archivo", sans-serif;
}

.section-title p {
  font-size: 16px;
  color: #6c757d;
  line-height: 1.8;
}

.section-title.text-center {
  text-align: center;
}

.resource-item {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 15px;
  padding: 40px 30px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  margin-bottom: 30px;
  border: 1px solid rgba(246, 236, 79, 0.2);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.resource-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  border-color: #f6ec4f;
}

.resource-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #f6ec4f, #f4d03f);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 25px;
  font-size: 32px;
  color: #2c3e50;
}

.resource-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.resource-content h3 {
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 15px;
  font-family: "Archivo", sans-serif;
}

.resource-content p {
  color: #6c757d;
  line-height: 1.6;
  margin-bottom: 25px;
  flex: 1;
}

.resource-link {
  color: #f6ec4f;
  text-decoration: none;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  margin-top: auto;
}

.resource-link:hover {
  color: #2c3e50;
  gap: 12px;
}

.btn {
  display: inline-block;
  padding: 15px 30px;
  background: transparent;
  color: #2c3e50;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
  border: 2px solid #2c3e50;
  cursor: pointer;
}

.btn:hover {
  background: #2c3e50;
  color: #fff;
  transform: translateY(-2px);
}

.btn i {
  margin-left: 8px;
  transition: transform 0.3s ease;
}

.btn:hover i {
  transform: translateX(4px);
}

/* Responsive Design */
@media only screen and (max-width: 991px) {
  .resource-center-section {
    padding: 80px 0;
  }
}

@media only screen and (max-width: 767px) {
  .resource-center-section {
    padding: 60px 0;
  }
  
  .section-title h2 {
    font-size: 32px;
  }
  
  .resource-item {
    padding: 30px 20px;
  }
  
  .resource-icon {
    width: 60px;
    height: 60px;
    font-size: 24px;
  }
  
  .resource-content h3 {
    font-size: 20px;
  }
}

@media only screen and (max-width: 399px) {
  .resource-center-section {
    padding: 40px 0;
  }
  
  .section-title h2 {
    font-size: 28px;
  }
  
  .resource-item {
    padding: 25px 15px;
  }
}
</style>
